// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c83dffb1323dd5305ec0","655":"22847211ea2743a1e3e9"}[chunkId] + ".js";
};